var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DescribeModeledDataStreamRequest_instances, _DescribeModeledDataStreamRequest_describeAssetRequest, _DescribeModeledDataStreamRequest_searchAssetPropertyRequest, _DescribeModeledDataStreamRequest_findAssetPropertyOnAsset, _DescribeModeledDataStreamRequest_handleError;
import { DescribeAssetRequest } from './describeAssetRequest';
import { SearchAssetPropertyRequest } from './searchAssetPropertyRequest';
/**
 * Creates a request to return the metadata for a modeled data stream.
 *
 * @remarks
 *
 * The created request is optimized to reduce the number of requests send using
 * caching of requests and optimistic control flow.
 */
export class DescribeModeledDataStreamRequest {
    constructor(client) {
        _DescribeModeledDataStreamRequest_instances.add(this);
        _DescribeModeledDataStreamRequest_describeAssetRequest.set(this, void 0);
        _DescribeModeledDataStreamRequest_searchAssetPropertyRequest.set(this, void 0);
        __classPrivateFieldSet(this, _DescribeModeledDataStreamRequest_describeAssetRequest, new DescribeAssetRequest(client), "f");
        __classPrivateFieldSet(this, _DescribeModeledDataStreamRequest_searchAssetPropertyRequest, new SearchAssetPropertyRequest(client), "f");
    }
    /**
     * Initiate the request to describe a modeled data stream.
     *
     * @remarks
     *
     * The request returns undefined if any exceptions are thrown to handle
     * failures gracefully.
     */
    async send({ assetPropertyId, assetId, assetModelId, }) {
        try {
            const asset = await __classPrivateFieldGet(this, _DescribeModeledDataStreamRequest_describeAssetRequest, "f").send(assetId);
            const assetPropertyOnAsset = __classPrivateFieldGet(this, _DescribeModeledDataStreamRequest_instances, "m", _DescribeModeledDataStreamRequest_findAssetPropertyOnAsset).call(this, {
                assetPropertyId,
                asset,
            });
            if (assetPropertyOnAsset) {
                const modeledDataStream = {
                    ...assetPropertyOnAsset,
                    assetId,
                    propertyId: assetPropertyId,
                    assetName: asset.assetName,
                };
                return modeledDataStream;
            }
            const searchedAssetProperty = await __classPrivateFieldGet(this, _DescribeModeledDataStreamRequest_searchAssetPropertyRequest, "f").send({
                assetPropertyId,
                assetId,
                assetModelId,
            });
            if (searchedAssetProperty) {
                const modeledDataStream = {
                    ...searchedAssetProperty,
                    assetId,
                    propertyId: assetPropertyId,
                    assetName: asset.assetName,
                };
                return modeledDataStream;
            }
        }
        catch (error) {
            return __classPrivateFieldGet(this, _DescribeModeledDataStreamRequest_instances, "m", _DescribeModeledDataStreamRequest_handleError).call(this, error);
        }
    }
}
_DescribeModeledDataStreamRequest_describeAssetRequest = new WeakMap(), _DescribeModeledDataStreamRequest_searchAssetPropertyRequest = new WeakMap(), _DescribeModeledDataStreamRequest_instances = new WeakSet(), _DescribeModeledDataStreamRequest_findAssetPropertyOnAsset = function _DescribeModeledDataStreamRequest_findAssetPropertyOnAsset({ assetPropertyId, asset: { assetProperties = [], assetCompositeModels = [] }, }) {
    const assetProperty = assetProperties.find(({ id }) => id === assetPropertyId);
    if (assetProperty) {
        return assetProperty;
    }
    const assetCompositeModelProperty = assetCompositeModels
        .flatMap(({ properties = [] }) => properties)
        .find(({ id }) => id === assetPropertyId);
    if (assetCompositeModelProperty) {
        return assetCompositeModelProperty;
    }
}, _DescribeModeledDataStreamRequest_handleError = function _DescribeModeledDataStreamRequest_handleError(error) {
    const errorMessage = `Failed to describe modeled data stream. Error: ${error}`;
    console.error(errorMessage);
    return undefined;
};
